module.exports = __webpack_public_path__ + "static/img/apple-store-badge-ca-ES.b208f50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge-ca-ES.png
// module id = soru
// module chunks = 1